// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/bgmapdot.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#products{
  background: white !important;
}

/* Trust Section Styles */
.trust-section {
  margin-top: 80px;
  margin-bottom: 80px;
  padding: 60px 0;
  border-radius: 12px;
}

.trust-title {
  color: rgba(0, 0, 0, 1);
  font-size: 33px;
  font-weight: 400;
  margin-bottom: 40px;
  font-family: 'Gilroy', sans-serif;
  text-align: center;
}

.trust-content {
  display: flex;
  gap: 15px;
  align-items: stretch;
  min-height: 400px;
}

.trust-visuals {
  flex: 1 1;
  display: flex;
  align-items: start;
}

.trust-image-grid {
  column-count: 2;
  column-gap: 10px;
}

.trust-image {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
}

.trust-features {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}

.trust-feature {
  display: flex;
  align-items: center;
  gap: 10px;
}

.trust-feature-icon {
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: bold;
}

.trust-feature-text {
  padding-left: 15px;
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
  font-weight: 500;
  font-family: 'Gilroy', sans-serif;
  line-height: 1.4;
}

.trust-feature-border {
  height: 2px;
  background-color: rgba(0, 0, 0, 0.05);
  margin: 12px 0;
  width: 100%;
}

/* Responsive design for trust section */
@media (max-width: 768px) {
  .trust-content {
    flex-direction: column;
    gap: 40px;
  }
  
  .trust-image-grid {
    max-width: 100%;
    gap: 15px;
  }
  
  .trust-title {
    font-size: 28px;
  }
  
  .trust-feature-text {
    font-size: 16px;
  }
}

/* Additional responsive styles for trust image grid */
@media (max-width: 480px) {
  .trust-image-grid {
    column-count: 1;
    column-gap: 8px;
  }
  
  .trust-image {
    margin-bottom: 8px;
  }
  
  .trust-image img {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
}

@media (min-width: 481px) and (max-width: 768px) {
  .trust-image-grid {
    column-count: 1;
    column-gap: 12px;
  }
  
  .trust-image {
    margin-bottom: 12px;
  }
  
  .trust-image img {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
}

@media (min-width: 769px) and (max-width: 1200px) {
  .trust-image-grid {
    column-count: 1;
    column-gap: 12px;
  }
  
  .trust-image {
    margin-bottom: 12px;
  }
  
  .trust-image img {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
}

.mapka-map-overlay-title{
    font-size: 40px;
    margin-bottom: 1rem;
    font-weight: 700;
}
.dotsmap{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 40px 20px;
  height: 700px;
}

@media (max-width: 1200px) {
  .dotsmap{
    background-image: none;
    background: linear-gradient(270deg, #0F4ABE 0%, #072258 100%);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 40px 20px;
    border-radius: 12px;
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.mapka-map-overlay-desc{
    font-size: 18px;
    margin-bottom: 1rem;
    font-weight: 400;
}

.partners-section {
  margin-top: 60px;
  margin-bottom: 60px;
  text-align: center;
}

.partners-title {
  color: rgba(0, 0, 0, 1);
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 40px;
  font-family: 'Gilroy', sans-serif;
  text-align: center;
}

.partners-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.partner-logo {
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 20px;
  font-family: 'Gilroy', sans-serif;
  border-radius: 12px;
  padding: 12px 24px;
  box-sizing: border-box;
  transition: box-shadow 0.2s;
}

.partner-logo img {
  width: 160px;
  height: 80px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  filter: grayscale(1) brightness(1.2);
  transition: all 0.3s ease;
}

.partner-logo img:hover {
    scale: 1.1;
}

@media (max-width: 900px) {
  .partners-row {
    flex-wrap: wrap;
    gap: 24px;
  }
  .partner-logo {
    min-width: 100px;
    min-height: 50px;
    font-size: 16px;
    padding: 8px 12px;
  }
  .partners-title {
    font-size: 24px;
  }
}

.partners-disclaimer {
  color: rgba(0, 0, 0, 0.7);
  text-align: center;
  font-size: 18px;
  margin-top: 40px;
  margin-bottom: 0;
  font-family: 'Gilroy', sans-serif;
  opacity: 0.85;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

/* Swiper Styles */
.partners-swiper-container {
  position: relative;
  margin-bottom: 40px;
}

.partners-swiper {
  padding-bottom: 40px;
}

.partners-swiper .swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
}

.partners-swiper .partner-logo {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border-radius: 12px;
  padding: 12px 24px;
  transition: all 0.3s ease;
}

.partners-swiper .partner-logo img {
  width: 160px;
  height: 80px;
  object-fit: contain;
  display: block;
  margin: 0 auto;
  transition: all 0.3s ease;
  filter: grayscale(0) brightness(1);
}

.partners-swiper .partner-logo img:hover {
  scale: 1.1;
}

/* Custom pagination styles */
.swiper-pagination {
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 20px;
  width: 100%;
}

.swiper-pagination-bullet {
  width: 6px;
  height: 6px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
}

.swiper-pagination-bullet-active {
  background: #0F4ABE;
  transform: scale(1.2);
}

/* Responsive swiper styles */
@media (max-width: 768px) {
  .partners-swiper .partner-logo img {
    width: 120px;
    height: 60px;
  }
  
  .partners-swiper .swiper-slide {
    height: 100px;
  }
  
  .swiper-pagination-bullet {
    width: 6px;
    height: 6px;
  }
}

@media (max-width: 480px) {
  .partners-swiper .partner-logo img {
    width: 100px;
    height: 50px;
  }
  
  .partners-swiper .swiper-slide {
    height: 80px;
  }
}

/* Testimonials Section Styles */
.testimonials-section {
  margin-top: 80px;
  margin-bottom: 0px;
  padding: 60px 0;
  background: rgba(248, 248, 248, 1);
  border-radius: 12px;
  position: relative;
}

.testimonials-title {
  background: linear-gradient(270deg, #0F4ABE 0%, #072258 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 60px;
  font-family: 'Gilroy', sans-serif;
  text-align: center;
}

.testimonials-container {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
}

.testimonials-quote-icon {
  position: absolute;
  top: -30px;
  left: 50px;
  z-index: 1;
  opacity: 0.3;
}

.testimonials-quote-icon svg {
  width: 75px;
  height: 75px;
  color: rgba(150, 150, 150, 1);
}

.testimonials-swiper {
  padding: 40px 0;
}

.testimonial-card {
  background: rgba(248, 248, 248, 1);
  border-radius: 16px;
  padding: 40px;
  text-align: center;
  position: relative;
  max-width: 600px;
  margin: 0 auto;
}

.testimonial-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 20px;
}

.testimonial-profile {
  display: flex;
  align-items: center;
}

.testimonial-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #f0f0f0;
}

.testimonial-rating {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
}

.rating-score {
  font-size: 18px;
  font-weight: 600;
  color: #0F4ABE;
  font-family: 'Gilroy', sans-serif;
}

.rating-stars {
  display: flex;
  gap: 2px;
  color: #000;
}

.rating-stars svg {
  width: 20px;
  height: 20px;
}

.testimonial-name {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  font-family: 'Gilroy', sans-serif;
}

.testimonial-text {
  font-size: 16px;
  line-height: 1.6;
  color: #666;
  font-family: 'Gilroy', sans-serif;
  font-weight: 400;
  max-width: 500px;
  margin: 0 auto;
}

.testimonials-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 30px;
}

.testimonials-pagination .swiper-pagination-bullet {
  width: 10px;
  height: 10px;
  background: #d1d5db;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 1;
}

.testimonials-pagination .swiper-pagination-bullet-active {
  background: #0F4ABE;
  transform: scale(1.2);
}

/* Navigation arrows for testimonials */
.testimonials-button-prev,
.testimonials-button-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 10;
}

.testimonials-button-prev {
  left: -60px;
}

.testimonials-button-next {
  right: -60px;
}

.testimonials-button-prev:hover,
.testimonials-button-next:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-50%) scale(1.05);
}

.testimonials-button-prev:hover svg path,
.testimonials-button-next:hover svg path {
  fill: #0F4ABE;
}

.testimonials-button-prev svg,
.testimonials-button-next svg {
  width: 24px;
  height: 24px;
}

.testimonials-button-prev svg path,
.testimonials-button-next svg path {
  transition: fill 0.3s ease;
}

/* Responsive design for testimonials */
@media (max-width: 768px) {
  .testimonials-section {
    padding: 40px 0;
    margin-top: 60px;
    margin-bottom: 60px;
  }
  
  .testimonials-title {
    font-size: 28px;
    margin-bottom: 40px;
  }
  
  .testimonial-card {
    padding: 30px 20px;
  }
  
  .testimonial-header {
    flex-direction: column;
    gap: 15px;
  }
  
  .testimonial-rating {
    align-items: center;
  }
  
  .testimonial-name {
    font-size: 18px;
  }
  
  .testimonial-text {
    font-size: 14px;
  }
  
  .testimonials-quote-icon {
    left: 20px;
    top: -20px;
  }
  
  .testimonials-quote-icon svg {
    width: 40px;
    height: 40px;
  }
  
  .testimonials-button-prev,
  .testimonials-button-next {
    width: 35px;
    height: 35px;
  }
  
  .testimonials-button-prev {
    left: -45px;
  }
  
  .testimonials-button-next {
    right: -45px;
  }
}

@media (max-width: 480px) {
  .testimonials-title {
    font-size: 24px;
  }
  
  .testimonial-card {
    padding: 25px 15px;
  }
  
  .testimonial-avatar {
    width: 50px;
    height: 50px;
  }
  
  .rating-score {
    font-size: 16px;
  }
  
  .rating-stars svg {
    width: 18px;
    height: 18px;
  }
  
  .testimonial-name {
    font-size: 16px;
  }
  
  .testimonial-text {
    font-size: 13px;
  }
  
  .testimonials-button-prev,
  .testimonials-button-next {
    width: 30px;
    height: 30px;
  }
  
  .testimonials-button-prev {
    left: -35px;
  }
  
  .testimonials-button-next {
    right: -35px;
  }
  
  .testimonials-button-prev svg,
  .testimonials-button-next svg {
    width: 18px;
    height: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/LandingPage/ProductsSection.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,cAAc;EACd,WAAW;AACb;;AAEA,wCAAwC;AACxC;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sDAAsD;AACtD;EACE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;AACA;EACE,yDAA6C;EAC7C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;IACtB,6DAA6D;IAC7D,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;AACF;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;EACE;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,6BAA6B;AAC7B;EACE;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;;EAEE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA,uCAAuC;AACvC;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["#products{\n  background: white !important;\n}\n\n/* Trust Section Styles */\n.trust-section {\n  margin-top: 80px;\n  margin-bottom: 80px;\n  padding: 60px 0;\n  border-radius: 12px;\n}\n\n.trust-title {\n  color: rgba(0, 0, 0, 1);\n  font-size: 33px;\n  font-weight: 400;\n  margin-bottom: 40px;\n  font-family: 'Gilroy', sans-serif;\n  text-align: center;\n}\n\n.trust-content {\n  display: flex;\n  gap: 15px;\n  align-items: stretch;\n  min-height: 400px;\n}\n\n.trust-visuals {\n  flex: 1;\n  display: flex;\n  align-items: start;\n}\n\n.trust-image-grid {\n  column-count: 2;\n  column-gap: 10px;\n}\n\n.trust-image {\n  width: 100%;\n  height: auto;\n  margin-bottom: 10px;\n}\n\n.trust-features {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 20px;\n}\n\n.trust-feature {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.trust-feature-icon {\n  font-size: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: bold;\n}\n\n.trust-feature-text {\n  padding-left: 15px;\n  color: rgba(0, 0, 0, 1);\n  font-size: 18px;\n  font-weight: 500;\n  font-family: 'Gilroy', sans-serif;\n  line-height: 1.4;\n}\n\n.trust-feature-border {\n  height: 2px;\n  background-color: rgba(0, 0, 0, 0.05);\n  margin: 12px 0;\n  width: 100%;\n}\n\n/* Responsive design for trust section */\n@media (max-width: 768px) {\n  .trust-content {\n    flex-direction: column;\n    gap: 40px;\n  }\n  \n  .trust-image-grid {\n    max-width: 100%;\n    gap: 15px;\n  }\n  \n  .trust-title {\n    font-size: 28px;\n  }\n  \n  .trust-feature-text {\n    font-size: 16px;\n  }\n}\n\n/* Additional responsive styles for trust image grid */\n@media (max-width: 480px) {\n  .trust-image-grid {\n    column-count: 1;\n    column-gap: 8px;\n  }\n  \n  .trust-image {\n    margin-bottom: 8px;\n  }\n  \n  .trust-image img {\n    width: 100%;\n    height: auto;\n    border-radius: 8px;\n  }\n}\n\n@media (min-width: 481px) and (max-width: 768px) {\n  .trust-image-grid {\n    column-count: 1;\n    column-gap: 12px;\n  }\n  \n  .trust-image {\n    margin-bottom: 12px;\n  }\n  \n  .trust-image img {\n    width: 100%;\n    height: auto;\n    border-radius: 8px;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1200px) {\n  .trust-image-grid {\n    column-count: 1;\n    column-gap: 12px;\n  }\n  \n  .trust-image {\n    margin-bottom: 12px;\n  }\n  \n  .trust-image img {\n    width: 100%;\n    height: auto;\n    border-radius: 8px;\n  }\n}\n\n.mapka-map-overlay-title{\n    font-size: 40px;\n    margin-bottom: 1rem;\n    font-weight: 700;\n}\n.dotsmap{\n  background-image: url('/public/bgmapdot.png');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  padding: 40px 20px;\n  height: 700px;\n}\n\n@media (max-width: 1200px) {\n  .dotsmap{\n    background-image: none;\n    background: linear-gradient(270deg, #0F4ABE 0%, #072258 100%);\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    padding: 40px 20px;\n    border-radius: 12px;\n    height: 500px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n}\n.mapka-map-overlay-desc{\n    font-size: 18px;\n    margin-bottom: 1rem;\n    font-weight: 400;\n}\n\n.partners-section {\n  margin-top: 60px;\n  margin-bottom: 60px;\n  text-align: center;\n}\n\n.partners-title {\n  color: rgba(0, 0, 0, 1);\n  font-size: 36px;\n  font-weight: 700;\n  margin-bottom: 40px;\n  font-family: 'Gilroy', sans-serif;\n  text-align: center;\n}\n\n.partners-row {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.partner-logo {\n  background: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 20px;\n  font-family: 'Gilroy', sans-serif;\n  border-radius: 12px;\n  padding: 12px 24px;\n  box-sizing: border-box;\n  transition: box-shadow 0.2s;\n}\n\n.partner-logo img {\n  width: 160px;\n  height: 80px;\n  object-fit: contain;\n  display: block;\n  margin: 0 auto;\n  filter: grayscale(1) brightness(1.2);\n  transition: all 0.3s ease;\n}\n\n.partner-logo img:hover {\n    scale: 1.1;\n}\n\n@media (max-width: 900px) {\n  .partners-row {\n    flex-wrap: wrap;\n    gap: 24px;\n  }\n  .partner-logo {\n    min-width: 100px;\n    min-height: 50px;\n    font-size: 16px;\n    padding: 8px 12px;\n  }\n  .partners-title {\n    font-size: 24px;\n  }\n}\n\n.partners-disclaimer {\n  color: rgba(0, 0, 0, 0.7);\n  text-align: center;\n  font-size: 18px;\n  margin-top: 40px;\n  margin-bottom: 0;\n  font-family: 'Gilroy', sans-serif;\n  opacity: 0.85;\n  max-width: 900px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Swiper Styles */\n.partners-swiper-container {\n  position: relative;\n  margin-bottom: 40px;\n}\n\n.partners-swiper {\n  padding-bottom: 40px;\n}\n\n.partners-swiper .swiper-slide {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 120px;\n}\n\n.partners-swiper .partner-logo {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border-radius: 12px;\n  padding: 12px 24px;\n  transition: all 0.3s ease;\n}\n\n.partners-swiper .partner-logo img {\n  width: 160px;\n  height: 80px;\n  object-fit: contain;\n  display: block;\n  margin: 0 auto;\n  transition: all 0.3s ease;\n  filter: grayscale(0) brightness(1);\n}\n\n.partners-swiper .partner-logo img:hover {\n  scale: 1.1;\n}\n\n/* Custom pagination styles */\n.swiper-pagination {\n  position: relative;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  margin-top: 20px;\n  width: 100%;\n}\n\n.swiper-pagination-bullet {\n  width: 6px;\n  height: 6px;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.swiper-pagination-bullet-active {\n  background: #0F4ABE;\n  transform: scale(1.2);\n}\n\n/* Responsive swiper styles */\n@media (max-width: 768px) {\n  .partners-swiper .partner-logo img {\n    width: 120px;\n    height: 60px;\n  }\n  \n  .partners-swiper .swiper-slide {\n    height: 100px;\n  }\n  \n  .swiper-pagination-bullet {\n    width: 6px;\n    height: 6px;\n  }\n}\n\n@media (max-width: 480px) {\n  .partners-swiper .partner-logo img {\n    width: 100px;\n    height: 50px;\n  }\n  \n  .partners-swiper .swiper-slide {\n    height: 80px;\n  }\n}\n\n/* Testimonials Section Styles */\n.testimonials-section {\n  margin-top: 80px;\n  margin-bottom: 0px;\n  padding: 60px 0;\n  background: rgba(248, 248, 248, 1);\n  border-radius: 12px;\n  position: relative;\n}\n\n.testimonials-title {\n  background: linear-gradient(270deg, #0F4ABE 0%, #072258 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-size: 36px;\n  font-weight: 700;\n  margin-bottom: 60px;\n  font-family: 'Gilroy', sans-serif;\n  text-align: center;\n}\n\n.testimonials-container {\n  position: relative;\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.testimonials-quote-icon {\n  position: absolute;\n  top: -30px;\n  left: 50px;\n  z-index: 1;\n  opacity: 0.3;\n}\n\n.testimonials-quote-icon svg {\n  width: 75px;\n  height: 75px;\n  color: rgba(150, 150, 150, 1);\n}\n\n.testimonials-swiper {\n  padding: 40px 0;\n}\n\n.testimonial-card {\n  background: rgba(248, 248, 248, 1);\n  border-radius: 16px;\n  padding: 40px;\n  text-align: center;\n  position: relative;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.testimonial-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.testimonial-profile {\n  display: flex;\n  align-items: center;\n}\n\n.testimonial-avatar {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid #f0f0f0;\n}\n\n.testimonial-rating {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 5px;\n}\n\n.rating-score {\n  font-size: 18px;\n  font-weight: 600;\n  color: #0F4ABE;\n  font-family: 'Gilroy', sans-serif;\n}\n\n.rating-stars {\n  display: flex;\n  gap: 2px;\n  color: #000;\n}\n\n.rating-stars svg {\n  width: 20px;\n  height: 20px;\n}\n\n.testimonial-name {\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 15px;\n  font-family: 'Gilroy', sans-serif;\n}\n\n.testimonial-text {\n  font-size: 16px;\n  line-height: 1.6;\n  color: #666;\n  font-family: 'Gilroy', sans-serif;\n  font-weight: 400;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.testimonials-pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  margin-top: 30px;\n}\n\n.testimonials-pagination .swiper-pagination-bullet {\n  width: 10px;\n  height: 10px;\n  background: #d1d5db;\n  border-radius: 50%;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  opacity: 1;\n}\n\n.testimonials-pagination .swiper-pagination-bullet-active {\n  background: #0F4ABE;\n  transform: scale(1.2);\n}\n\n/* Navigation arrows for testimonials */\n.testimonials-button-prev,\n.testimonials-button-next {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 10;\n}\n\n.testimonials-button-prev {\n  left: -60px;\n}\n\n.testimonials-button-next {\n  right: -60px;\n}\n\n.testimonials-button-prev:hover,\n.testimonials-button-next:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  transform: translateY(-50%) scale(1.05);\n}\n\n.testimonials-button-prev:hover svg path,\n.testimonials-button-next:hover svg path {\n  fill: #0F4ABE;\n}\n\n.testimonials-button-prev svg,\n.testimonials-button-next svg {\n  width: 24px;\n  height: 24px;\n}\n\n.testimonials-button-prev svg path,\n.testimonials-button-next svg path {\n  transition: fill 0.3s ease;\n}\n\n/* Responsive design for testimonials */\n@media (max-width: 768px) {\n  .testimonials-section {\n    padding: 40px 0;\n    margin-top: 60px;\n    margin-bottom: 60px;\n  }\n  \n  .testimonials-title {\n    font-size: 28px;\n    margin-bottom: 40px;\n  }\n  \n  .testimonial-card {\n    padding: 30px 20px;\n  }\n  \n  .testimonial-header {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .testimonial-rating {\n    align-items: center;\n  }\n  \n  .testimonial-name {\n    font-size: 18px;\n  }\n  \n  .testimonial-text {\n    font-size: 14px;\n  }\n  \n  .testimonials-quote-icon {\n    left: 20px;\n    top: -20px;\n  }\n  \n  .testimonials-quote-icon svg {\n    width: 40px;\n    height: 40px;\n  }\n  \n  .testimonials-button-prev,\n  .testimonials-button-next {\n    width: 35px;\n    height: 35px;\n  }\n  \n  .testimonials-button-prev {\n    left: -45px;\n  }\n  \n  .testimonials-button-next {\n    right: -45px;\n  }\n}\n\n@media (max-width: 480px) {\n  .testimonials-title {\n    font-size: 24px;\n  }\n  \n  .testimonial-card {\n    padding: 25px 15px;\n  }\n  \n  .testimonial-avatar {\n    width: 50px;\n    height: 50px;\n  }\n  \n  .rating-score {\n    font-size: 16px;\n  }\n  \n  .rating-stars svg {\n    width: 18px;\n    height: 18px;\n  }\n  \n  .testimonial-name {\n    font-size: 16px;\n  }\n  \n  .testimonial-text {\n    font-size: 13px;\n  }\n  \n  .testimonials-button-prev,\n  .testimonials-button-next {\n    width: 30px;\n    height: 30px;\n  }\n  \n  .testimonials-button-prev {\n    left: -35px;\n  }\n  \n  .testimonials-button-next {\n    right: -35px;\n  }\n  \n  .testimonials-button-prev svg,\n  .testimonials-button-next svg {\n    width: 18px;\n    height: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
